export default {
  show: false
}



// WEBPACK FOOTER //
// ./src/plugins/loader/vuex/state.js